<div class="popupCloseParent">
  <span class="imgCarousel_popClose" (click)="closeDialog()">x</span>
</div>
<div class="slider-container">
  <div class="slider-wrapper">
    @for (image of images; track image; let i = $index) {
      <div class="slider-item">
        <img [src]="baseUrl + image.url" [alt]="getFileName(baseUrl + image.url)">
        <span class="image-name">{{ getFileName(baseUrl + image.url) }}</span>
      </div>
    }
  </div>
  <a class="prev" (click)="plusSlides(-1)"><i class="fa-solid fa-chevron-left"></i></a>
  <a class="next" (click)="plusSlides(1)"><i class="fa-solid fa-chevron-right"></i></a>
  <div class="thumbnail-container">
    @for (image of images; track image; let i = $index) {
      <div class="thumbnail" (click)="currentSlide(i)" [class.active]="i === 0">
        <!-- <img [src]="baseUrl + image.url" [alt]="getFileName(baseUrl + image.url)"> -->
        <img [src]="getImageSrc(image)" [alt]="getFileName(baseUrl + image.url)">
      </div>
    }
  </div>
</div>
<div class="dialog-footer">
  <button class="imgCarouselDone_btn" (click)="closeDialog()">{{"returnsUK.donelabel" | cxTranslate}}</button>
</div>